<div class="game-container">
  <app-header class="nav-header" *ngIf="authenticated"></app-header>
  <div class="header">
    <div class="video-container">
      <div class="timer">
        <app-timer-v2 [countdown]="countdown" *ngIf="countdown > 0"></app-timer-v2>
      </div>
      <app-live-video [dealerId]="dealerId"></app-live-video>
      <div class="mavrick-card-container" *ngIf="showMaverickCard">
        <app-picked-card [card]="maverickCard[0]" label="Maverick"></app-picked-card>
      </div>
      <div class="base-card-container" *ngIf="showPlayerCards">
        <app-picked-card
          class="mr-2"
          [card]="playerCards[0]"
          label="1ST Base Card"
        ></app-picked-card>
        <app-picked-card [card]="playerCards[1]" label="2ND Base Card"></app-picked-card>
      </div>
    </div>
    <div class="betting-container">
      <app-betting-section [countdown]="countdown" [dealerId]="dealerId"></app-betting-section>
    </div>
  </div>
  <div class="history-container">
    <app-game-history></app-game-history>
  </div>
  <div class="history-container-mobile">
    <app-game-history-mobile></app-game-history-mobile>
  </div>
</div>